import { render } from "./BundlingDialog.vue?vue&type=template&id=e2ca03be"
import script from "./BundlingDialog.vue?vue&type=script&lang=js"
export * from "./BundlingDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__